import { render, staticRenderFns } from "./KriminalitasEdit.vue?vue&type=template&id=4d1c9a20"
import script from "./KriminalitasEdit.vue?vue&type=script&lang=js"
export * from "./KriminalitasEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports